import PasswordLogin, { PasswordLoginData } from './loginMethods/passwordLogin';
import StudentIDLogin, { StudentIDLoginData } from './loginMethods/studentIDLogin';
import SSCLogin, { SSCLoginData } from './loginMethods/sscLogin';
import { getEnv } from '../../environment/resolve';

export const F2BCore = {
	Environment: {
		registerStatusListener: (listerner) => listerner(true),
		unregisterStatusListener: () => {},
		registerConnectionDateChangeListener: () => {},
		unregisterConnectionDateChangeListener: () => {},
	},
	Reporter: {
		registerChangeListener: () => {},
		removeChangeListener: () => {},
		getLeftReportsToUpload: () => 0,
	},
	AppSettings: {
		// Getter so appHost resolves from the browser hostname at access time.
		get secureURL() { return getEnv().appHost; },
	}
}

export const Login = {
	LocalData: (...args) => {
		const self = this;
		Object.entries(([k, v]) => { sefl[k] = v; });
	},
	PasswordLogin, PasswordLoginData,
	StudentIDLogin, StudentIDLoginData,
	SSCLogin, SSCLoginData,
};

const setUpLoginMethod = (data, userData, DataClass, MethodClass) => {
	const loginData = new DataClass();
	Object.entries(data).forEach(([key, value]) => { loginData[key] = value; });
	Object.entries(userData ?? {}).forEach(([key, value]) => { loginData.userData[key] = value; });

	return new MethodClass(loginData);
}

export const eventHandler = ({ event, userData, ...data }, { source, origin }) => {
	const respondToApp = (response) => source.postMessage(response, origin);
	const logIn = (loginMethod) => {
		loginMethod.on('onSuccessLogin', (result) => respondToApp({ event, data: { success: true, result: result.asPostable() } }));
		loginMethod.on('onFailLogin', (result) => respondToApp({ event, data: { success: false, result: result.asPostable() } }));
		loginMethod.login();
	};
	switch(event){
		case 'CHANGE_LANGUAGE':
		case 'info':
		case 'log':
		case 'warn':
		case 'error':
			break; //ignore the above
		case 'IS_INTERNET_AVAILABLE':
			return respondToApp({ event, data: true });
		case 'GET_LEFT_REPORTS_TO_UPLOAD':
			return respondToApp({ event, data: 0 });
		case 'GET_ENVIRONMENT':
		case 'GET_LOCAL_DATA':
		case 'GET_APP_SETTINGS':
			return respondToApp({ event, data: F2BCore.AppSettings });
		case 'LOGIN_USING_SSC':
			return logIn(setUpLoginMethod(data, userData, SSCLoginData, SSCLogin));
		case 'LOGIN_USING_STUDENT_ID':
			return logIn(setUpLoginMethod(data, userData, StudentIDLoginData, StudentIDLogin));
		case 'LOGIN_USING_PASSWORD':
			return logIn(setUpLoginMethod(data, userData, PasswordLoginData, PasswordLogin));
		default:
			console.warn(`unknown LoginModule event: ${event}`);
	}
};
